import React from "react";
import * as _ from "lodash";

/**
 * The list of clues as they appear on the game detail screen.
 *
 * iconList object is an array of the form { [name=..., url=...], [name=..., url=...], etc}
 * callback is a function with one argument, name.
 */

const ClueIconChooser = ( props ) => {
   const { iconList, callback } = props;

   if (!iconList) {
      return <div> Loading... </div>
   }

   if (iconList.length === 0) {
      return <div> No icons. </div>
   }

   const icons = iconList.map( (item) => {
      const { name, url } = item;

      return (
         <div key={name} className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <div onClick={() => callback(name)}
                 className="icon thumbnail clue-icon">
               <img src={url} alt={name + " icon"}/>
            </div>
         </div>
      );
   });

   return (
      <div className="clear-left row">
         {icons}
      </div>
   )
};

/** Get and formulate icon URL given clue icon set, existing clue, if any, and local state, if any.
 *
 * @param clueIcons    The clue icon to url set.
 * @param clue         Existing clue.  (May contain previously chosen icon in "icon" field).
 * @param localState   The local state from which to draw "clueIcon" from, if locally selected.
 * @param useDefault   if true, use first icon as default.  If false, return null.
 * @returns {null|*}
 */
export function getIconUrl(clueIcons, clue, localState, useDefault) {

   if (!clueIcons) return null;

   // Get icon name from local state (indicates user has made a new selection on this page).
   var iconName  = localState ? localState.iconName : null;

   // Or from pre-existing clue if local state is null
   if (!iconName && !!clue) {
      iconName = clue.icon;
   }

   // if we still don't have an iconName, user 0th icon as a default.
   if (!iconName) {
      if (useDefault && clueIcons.length > 0) return clueIcons[0].url;
      else return null;
   }
   const iconMap = _.keyBy(clueIcons, 'name');
   const url = iconMap[iconName].url;
   if (!url) {
      console.warn("No clue icon url for name: " + iconName);
   }
   return url;
}



export default ClueIconChooser;


// WEBPACK FOOTER //
// ./src/components/clues/ClueIconChooser.js